// IMPORT DEPENDENCIES
import {BASE_URL} from '../../urls/base/base'

//EXPORT LOGIN 
export const LOGIN_URL = `${BASE_URL}/auth/login`;